module.exports = __webpack_public_path__ + "static/media/results_charts.6e0ba374.png";